
import { join, concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { CountingFilter, toCountingPositions, CountingMsg, positionKey } from "./Types.js";
import { unwrap, map, defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { equals, createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { NumberInputWithSubmit } from "../../Components/Input.js";
import { empty as empty_1, toArray, isEmpty, length, filter, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { TextButton } from "../../Components/Button.js";
import Check from "../../../public/assets/icons/Check.svg";
import { append, empty, singleton, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { toLocalTime, toString } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import Delete_1 from "../../../public/assets/icons/Delete_1.svg";
import { TabsMenu } from "../../Widgets/TabsMenu.js";
import { SuccessAlert } from "../../Components/Alert.js";
import { Table } from "../../Widgets/Table/Table.js";
import { ColumnDefinition$1, CellContent } from "../../Widgets/Table/Types.js";

function positionTestId(position) {
    return concat("counting-position-", ...positionKey(position.ResultType));
}

function formatQuantity(t, position, quantity) {
    const unit = defaultArg(map(t, position.UnitTranslationKey), "");
    return (`${quantity} ${unit}`).trim();
}

function QuantityInput(props) {
    let elems_1, elems, Label_1;
    const t = useTranslation()[0];
    let currentValue;
    const matchValue = props.Position.Result;
    let matchResult, quantity;
    if (matchValue == null) {
        matchResult = 1;
    }
    else if (matchValue.Value.tag === 0) {
        matchResult = 1;
    }
    else {
        matchResult = 0;
        quantity = matchValue.Value.fields[0];
    }
    switch (matchResult) {
        case 0: {
            currentValue = quantity;
            break;
        }
        default:
            currentValue = undefined;
    }
    const patternInput_1 = reactApi.useState(currentValue);
    const setDraft = patternInput_1[1];
    const draft = patternInput_1[0];
    const patternInput_2 = reactApi.useState(undefined);
    const setValidation = patternInput_2[1];
    const inputRef = reactApi.useRef(undefined);
    const dependencies = [currentValue, positionKey(props.Position.ResultType)];
    reactApi.useEffect(() => {
        setDraft(currentValue);
    }, dependencies);
    let isInteger;
    const matchValue_1 = props.Position.ResultType;
    switch (matchValue_1.tag) {
        case 0:
        case 2: {
            isInteger = false;
            break;
        }
        default:
            isInteger = true;
    }
    const save = () => {
        let value;
        let matchResult_1, value_1;
        if (draft == null) {
            matchResult_1 = 1;
        }
        else if ((value = draft, (value >= 0) && (!isInteger ? true : (Math.floor(value) === value)))) {
            matchResult_1 = 0;
            value_1 = draft;
        }
        else {
            matchResult_1 = 1;
        }
        switch (matchResult_1) {
            case 0: {
                setValidation(undefined);
                props.OnSave(value_1);
                break;
            }
            case 1: {
                setValidation(t("stocktaking.counting.invalid_quantity"));
                break;
            }
        }
    };
    return reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "items-start", "gap-3"])], (elems_1 = [reactElement("div", createObj(ofArray([["className", join(" ", ["w-32"])], (elems = [createElement(NumberInputWithSubmit, {
        ComponentState: props.ComponentState,
        InputRef: inputRef,
        OnChange: (value_4) => {
            setValidation(undefined);
            setDraft(value_4);
        },
        OnSubmit: save,
        TestId: concat(props.TestId, ..."-quantity"),
        ValidationMessage: unwrap(patternInput_2[0]),
        Value: unwrap(draft),
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), createElement(TextButton, (Label_1 = t("general.save"), {
        ComponentState: props.ComponentState,
        Icon: Check(),
        Label: Label_1,
        OnClick: save,
        TestId: concat(props.TestId, ..."-save"),
        Variant: "default",
    }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
}

function ResultCell(props) {
    let elems;
    const t = useTranslation()[0];
    return reactElement("div", createObj(ofArray([["data-test-id", concat(positionTestId(props.Position), ..."-result")], ["className", join(" ", ["flex", "flex-col"])], (elems = toList(delay(() => {
        let expected, matchValue_4;
        const matchValue = props.Position.Result;
        if (matchValue == null) {
            if (props.ShowNotCounted) {
                return singleton(reactElement("div", {
                    className: join(" ", ["text-sm", "text-black"]),
                    children: t("stocktaking.counting.not_counted"),
                }));
            }
            else {
                return empty();
            }
        }
        else {
            const result = matchValue;
            let isMatchingExpectation;
            const matchValue_1 = result.Value;
            const matchValue_2 = props.Position.ExpectedQuantity;
            isMatchingExpectation = ((matchValue_1.tag === 1) ? ((matchValue_2 == null) ? true : ((expected = matchValue_2, matchValue_1.fields[0] === expected))) : matchValue_1.fields[0]);
            return append(singleton(reactElement("div", {
                className: join(" ", toList(delay(() => append(singleton("font-semibold"), delay(() => (isMatchingExpectation ? singleton("text-primary") : singleton("text-red"))))))),
                children: (matchValue_4 = result.Value, (matchValue_4.tag === 1) ? formatQuantity(t, props.Position, matchValue_4.fields[0]) : (matchValue_4.fields[0] ? t("stocktaking.found") : t("stocktaking.not_found"))),
            })), delay(() => singleton(reactElement("div", {
                className: join(" ", ["text-xs", "text-black"]),
                children: concat(result.ViaEmailLink ? concat(result.RecordedBy, " (", t("stocktaking.email_link.badge"), ...")") : result.RecordedBy, ", ", ...toString(toLocalTime(result.Timestamp), "dd.MM.yyyy HH:mm")),
            }))));
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

function ActionsCell(props) {
    let elems;
    const t = useTranslation()[0];
    const testId = positionTestId(props.Position);
    return reactElement("div", createObj(ofArray([["data-test-id", testId], ["className", join(" ", ["flex", "flex-wrap", "items-center", "gap-5"])], (elems = toList(delay(() => {
        let matchValue, toolId, Label;
        return append((matchValue = props.Position.ResultType, (matchValue.tag === 1) ? singleton(createElement(QuantityInput, {
            ComponentState: props.ComponentState,
            OnSave: (quantity) => {
                props.Dispatch(new CountingMsg(2, [matchValue.fields[0], ~~quantity]));
            },
            Position: props.Position,
            TestId: testId,
        })) : ((matchValue.tag === 2) ? singleton(createElement(QuantityInput, {
            ComponentState: props.ComponentState,
            OnSave: (quantity_1) => {
                props.Dispatch(new CountingMsg(3, [matchValue.fields[0], quantity_1]));
            },
            Position: props.Position,
            TestId: testId,
        })) : ((toolId = matchValue.fields[0], append(singleton(createElement(TextButton, (Label = t("stocktaking.found"), {
            ComponentState: props.ComponentState,
            Icon: Check(),
            Label: Label,
            OnClick: () => {
                props.Dispatch(new CountingMsg(1, [toolId, true]));
            },
            TestId: concat(testId, ..."-found"),
            Variant: "default",
        }))), delay(() => {
            let Label_1;
            return singleton(createElement(TextButton, (Label_1 = t("stocktaking.not_found"), {
                ComponentState: props.ComponentState,
                Icon: Delete_1(),
                Label: Label_1,
                OnClick: () => {
                    props.Dispatch(new CountingMsg(1, [toolId, false]));
                },
                TestId: concat(testId, ..."-not-found"),
                Variant: "redButton",
            })));
        })))))), delay(() => {
            if (props.Position.Result == null) {
                return empty();
            }
            else {
                return singleton(createElement(TextButton, {
                    ComponentState: props.ComponentState,
                    Label: t("stocktaking.counting.remove_result"),
                    OnClick: () => {
                        props.Dispatch(new CountingMsg(4, [props.Position.ResultType]));
                    },
                    TestId: concat(testId, ..."-remove"),
                    Variant: "muted",
                }));
            }
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function CountingView(props) {
    let elems_5;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const positions = toCountingPositions(props.StocktakingList);
    const openPositions = filter((position) => (position.Result == null), positions);
    const filteredPositions = (props.Counting.CountingFilter.tag === 1) ? positions : openPositions;
    const componentState = props.Counting.FormState.IsLoading ? "disabled" : "enabled";
    const openPositionsLabel = t("stocktaking.counting.open_positions");
    const allPositionsLabel = t("stocktaking.counting.all_positions");
    return reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-counting-view"], ["className", join(" ", ["row-start-2", "col-span-2", "flex", "flex-col", "gap-6", "bg-white", "rounded", "px-4", "py-6", "md:px-12", "md:py-9"])], (elems_5 = toList(delay(() => {
        let elems, arg_1;
        return append(singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["flex", "justify-between", "items-center"])], (elems = [reactElement("div", {
            className: join(" ", ["font-ubuntu", "font-medium", "text-xl"]),
            children: t("stocktaking.counting.title"),
        }), reactElement("div", {
            "data-test-id": "stocktaking-counting-progress",
            className: join(" ", ["text-black"]),
            children: (arg_1 = {
                counted: length(positions) - length(openPositions),
                total: length(positions),
            }, patternInput[1].t("stocktaking.counting.progress", arg_1)),
        })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => {
            let Label, Label_1;
            return append(singleton(createElement(TabsMenu, {
                Tabs: ofArray([(Label = (`${openPositionsLabel} (${length(openPositions)})`), {
                    IsSelected: equals(props.Counting.CountingFilter, new CountingFilter(0, [])),
                    Label: Label,
                    OnClick: () => {
                        props.Dispatch(new CountingMsg(0, [new CountingFilter(0, [])]));
                    },
                    TestId: "stocktaking-counting-filter-open",
                }), (Label_1 = (`${allPositionsLabel} (${length(positions)})`), {
                    IsSelected: equals(props.Counting.CountingFilter, new CountingFilter(1, [])),
                    Label: Label_1,
                    OnClick: () => {
                        props.Dispatch(new CountingMsg(0, [new CountingFilter(1, [])]));
                    },
                    TestId: "stocktaking-counting-filter-all",
                })]),
            })), delay(() => {
                let elems_1, elems_4, TableRows;
                return (isEmpty(openPositions) && equals(props.Counting.CountingFilter, new CountingFilter(0, []))) ? singleton(reactElement("div", createObj(ofArray([["data-test-id", "stocktaking-counting-all-counted"], (elems_1 = [createElement(SuccessAlert, {
                    Label: "stocktaking.counting.all_counted",
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : singleton(reactElement("div", createObj(ofArray([["className", join(" ", ["[&>div]:!h-auto", "[&>div>div]:!h-auto"])], (elems_4 = [createElement(Table, (TableRows = toArray(filteredPositions), {
                    ColumnDefinitions: [new ColumnDefinition$1("image", "", t("general.image"), (position_1) => (new CellContent(6, [position_1.ImageUrl])), "none", "image"), new ColumnDefinition$1("inventoryNumber", "", t("general.inventory_number"), (position_2) => (new CellContent(0, [position_2.InventoryNumber])), "text", "text"), new ColumnDefinition$1("name", "", t("general.name"), (position_3) => (new CellContent(0, [position_3.Name])), "text", "text"), new ColumnDefinition$1("serialNumber", "", t("general.serial_number"), (position_4) => (new CellContent(0, [position_4.SerialNumber])), "text", "text"), new ColumnDefinition$1("qrCodeIds", "", t("general.qr_code"), (position_5) => (new CellContent(0, [join(", ", position_5.QRCodeIds)])), "text", "text"), new ColumnDefinition$1("storageSpace", "", t("tool.storage_space"), (position_6) => (new CellContent(0, [position_6.StorageSpace])), "select", "text"), new ColumnDefinition$1("expectedQuantity", "", t("stocktaking.counting.expected_quantity"), (position_7) => {
                        let matchValue_1;
                        return new CellContent(0, [(matchValue_1 = position_7.ExpectedQuantity, (matchValue_1 == null) ? "1" : formatQuantity(t, position_7, matchValue_1))]);
                    }, "none", "text"), new ColumnDefinition$1("result", "", t("stocktaking.counting.result"), (position_8) => {
                        let elems_2;
                        return new CellContent(2, [reactElement("div", createObj(ofArray([["key", positionKey(position_8.ResultType)], (elems_2 = [createElement(ResultCell, {
                            Position: position_8,
                            ShowNotCounted: equals(props.Counting.CountingFilter, new CountingFilter(1, [])),
                        })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))]);
                    }, "none", "text"), new ColumnDefinition$1("record", "", t("stocktaking.counting.record"), (position_9) => {
                        let elems_3;
                        return new CellContent(2, [reactElement("div", createObj(ofArray([["key", positionKey(position_9.ResultType)], (elems_3 = [createElement(ActionsCell, {
                            ComponentState: componentState,
                            Dispatch: props.Dispatch,
                            Position: position_9,
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))]);
                    }, "none", "text")],
                    Controls: empty_1(),
                    Options: {
                        BorderStyle: "row",
                        CSVDownload: false,
                        ConfigurableColumns: false,
                        CustomTableFilters: false,
                        DefaultSortColumn: ["name", "asc"],
                        Fullscreen: false,
                        GlobalSearch: true,
                        RowSelection: "disabled",
                        SaveTableConfiguration: false,
                    },
                    TableKey: "stocktaking-counting",
                    TableRows: TableRows,
                }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_5))])])));
}

